import React from 'react'
import { useProject } from '../../../../../model/hooks/useProject'
import { ProjectLoadingSkeleton } from '../../../layout/ProjectLoadingSkeleton'
import { ProjectLayout } from '../../../layout/ProjectLayout'
import { Button } from '../../../../../components/ui/button'
import { ProjectSimpleForm } from '../ProjectSimpleForm'
import { Divider } from '../../../../../components/Divider'
import { useDeleteProjectMutation } from '../../../../../model/api/project/useDeleteProjectMutation'
import { useToast } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../../../../../model/enums/RoutesEnum'

interface Props {}

export const ProjectOptions: React.FC<Props> = (props) => {
  const { project } = useProject()
  const { mutateAsync: deleteProject, isLoading: isDeleting } = useDeleteProjectMutation()
  const toast = useToast()
  const navigate = useNavigate()

  if (!project) {
    return <ProjectLoadingSkeleton />
  }

  const onDelete = async () => {
    if (!window.confirm('Opravdu chcete odstranit tento projekt a všechny jeho data?')) {
      return
    }

    try {
      await deleteProject({ projectId: project.id })
      toast({
        title: 'Projekt byl úspěšně odstraněn',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top',
      })
      navigate(`${RoutesEnum.PROJECTS}`)
    } catch (err) {
      console.error(err)
      toast({
        title: 'Chyba při odstraňování projektu',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      })
    }
  }

  return (
    <ProjectLayout project={project}>
      <div>
        <div className="flex flex-col md:flex-row flex-wrap justify-between items-center gap-6 sm:flex-nowrap ">
          <h1 className="text-base font-semibold leading-7 text-gray-900">Další možnosti</h1>
          <div className="md:w-auto w-full"></div>
        </div>
        <div className="my-5 flex justify-center">
          <Button onClick={onDelete} type="button" variant="destructive" isLoading={isDeleting}>
            Odstranit projekt
          </Button>
        </div>
      </div>
    </ProjectLayout>
  )
}
